import apiClient from "./apiClient";
const resource = '/inventory-stocks?location=warehouse';

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, {params});
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(uuid, data) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },

};